(function() {
  // Selectors commonly used for the slideout cart/drawer
  const DRAWER_SELECTORS = [
    '.cart-drawer', '.slideout-cart', '.mini-cart', '.ajaxcart', '[data-cart-drawer]'
  ];

  function isInDrawer(el) {
    if (!el) return false;
    return DRAWER_SELECTORS.some(sel => el.closest(sel));
  }

  function removeDrawerDuplicate() {
    document.querySelectorAll('a.link_to_cart[href="/cart"]').forEach(link => {
      if (isInDrawer(link)) link.remove();
    });
  }

  const observer = new MutationObserver(removeDrawerDuplicate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      removeDrawerDuplicate();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    removeDrawerDuplicate();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
